module.exports = __webpack_public_path__ + "img/sexe.23d4601.svg";


//////////////////
// WEBPACK FOOTER
// ./static/images/indicateurs-icons/sexe.svg
// module id = IToy
// module chunks = 7